import {
  Box,
  Editable, EditableInput, EditablePreview, Flex, FormControl, FormLabel, IconButton,
  Switch,
  Text,
  useEditableControls,
} from '@chakra-ui/react';
import { BsPencilSquare } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setFormEnabled, setFormName } from './formSlice';
import { getFormUrl } from '../../helpers';

const EditableControls = () => {
  const {
    isEditing,
    getEditButtonProps,
  } = useEditableControls();

  return !isEditing ? (
    <Box position="absolute" right="0" top="0">
      <IconButton icon={<BsPencilSquare />} {...getEditButtonProps()} size="sm" />
    </Box>
  ) : null;
};

const MainSetup = ({ form }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const handleNameChange = (name) => {
    dispatch(setFormName(name));
  };
  const handleChangeEnabled = (enabled) => {
    console.log(enabled.target.checked);
    dispatch(setFormEnabled(enabled.target.checked));
  };
  return (
    <Flex direction="column" minH="250px">
      {form.name && (
      <Editable value={form.name} position="relative" mb="4" height="38px" onChange={handleNameChange}>
        <EditablePreview w="100%" fontWeight="bold" fontSize="xl" cursor="pointer" />
        <EditableInput />
        <EditableControls />
      </Editable>
      )}
      {pathname.startsWith('/form') && (
        <>
          <FormControl display="flex" alignItems="center">
            <FormLabel htmlFor="email-alerts" mb="0">
              Enabled
            </FormLabel>
            <Switch id="email-alerts" isChecked={form.enabled} onChange={handleChangeEnabled} />
          </FormControl>
          <FormControl display="flex" alignItems="center">
            <FormLabel htmlFor="email-alerts" mb="0">
              Form url:
            </FormLabel>
            <Text my="4">
              {getFormUrl(form)}
            </Text>
          </FormControl>
        </>
      )}
    </Flex>
  );
};

export default MainSetup;
